import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DefautProduitManqueAccessoireStep from './DefautProduitManqueAccessoireStep';

class DefautProduitManqueAccessoireStepContainer extends React.Component {
    
    render() {
        return (
            <DefautProduitManqueAccessoireStep {...this.props} />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let colisLogistiques = state.colisLogistique.colisLogistiques.items;

    return {
        colisLogistiques: colisLogistiques
    };
};

//const mapDispatchToProps = (dispatch) => ({
//});

DefautProduitManqueAccessoireStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(DefautProduitManqueAccessoireStepContainer);